import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccessCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5.29474 10.6425L8.85399 14.247L14.917 8.21799L13.507 6.79999L8.86799 11.414L6.71874 9.23749L5.29474 10.6425Z",
			fill: "#397D0C"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 10C1 14.962 5.037 19 10 19C14.963 19 19 14.962 19 10C19 5.038 14.963 1 10 1C5.037 1 1 5.038 1 10ZM3 10C3 6.14 6.141 3 10 3C13.859 3 17 6.14 17 10C17 13.86 13.859 17 10 17C6.141 17 3 13.86 3 10Z",
			fill: "#397D0C"
		})
	]
});
const ForwardRef = forwardRef(SvgSuccessCheck);
export { ForwardRef as ReactComponent };
